import { useContext, useMemo } from 'react';

import { Column } from '@hdi-seguros/web-components.card';
import { SectionSummary } from '../../../../../../../shared/components';

import { StepOneFormContext } from '../../contexts/StepOneForm';

import { formattedPrice } from '../../../../../../../shared/utils';

export const Summary = () => {
  const { totalSelected } = useContext(StepOneFormContext);

  const summaryInfo: Array<Column[]> = useMemo(() => {
    return [
      [
        {
          label: 'Total',
          value: <b>{`$ ${formattedPrice(totalSelected.toString())}`}</b>,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 10 },
            lg: { span: 7 },
          },
        },
      ],
    ];
  }, [totalSelected]);

  return <SectionSummary summaryInfo={summaryInfo} />;
};
